import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation CreateOrUpdateUser($uid: ID!, $input: UserInput!) {
    createOrUpdateUser(id: $uid, input: $input) {
      id
    }
  }
`);
